<script>
  import { beforeUpdate } from 'svelte';
  import AxisY from './yaxis.svelte';
  import Block from './Block.svelte';
  import { scaleLinear, scalePow } from 'd3-scale';
  import { fade } from 'svelte/transition';
  import { getSpectrumData } from './helper.js';

  export let type = 'bands';
  export let totalIndex = 0;
  export let annotations = [];
  export let index;
  export let isInset = false;
  export let data = [];
  export let domain = [0, 100];
  export let paddingLeft = 55;

  export let height = 100;
  export let width = 100;
  export let initialized = false;
  $: paddingRight = width > 860 ? 140 : 125;
  $: lineGap = width > 860 ? 20 : 10;
  let specData = type == 'spectrum' ? getSpectrumData(data) : { groups: [] };
  let rangeContainer;

  let prevDomain;

  let scale = scaleLinear()
    .domain(domain)
    .range([height, 0]);
  let initScale = scaleLinear()
    .domain(domain)
    .range([height, 0]);

  $: {
    console.log(domain);
    let newScale = scaleLinear()
      .domain(domain)
      .range([height, 0]);
    if (isInset && index == 0) {
      newScale = scalePow()
        .exponent(0.1)
        .domain(domain)

        .range([height, 0]);
    }

    initScale = scale;

    scale = newScale;
  }

  function isVisible(index, type, isInset) {
    if (type == 'bands') {
      if (index > 0 && isInset) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  }
</script>

<style type="text/scss">.blockContainer {
  height: 100%;
  position: absolute;
  right: 0;
  top: 0; }
  .blockContainer:before {
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    border-top: 1px solid #ccc;
    z-index: -1; }

.blockAnnotations {
  height: 100%;
  position: absolute;
  top: 0; }
</style>

{#if isVisible(index, type, isInset)}

  <AxisY
    {scale}
    {initScale}
    {domain}
    {width}
    {paddingLeft}
    {paddingRight}
    {isInset}
    {initialized} />

  <div
    class="blockContainer"
    style="width: {width - paddingLeft - paddingRight}px; right: {paddingRight}px;"
    bind:this={rangeContainer}>

    <Block
      {data}
      {scale}
      {domain}
      width={width - paddingLeft - paddingRight}
      {height}
      {paddingLeft}
      {paddingRight}
      {isInset}
      {initialized}
      {index}
      {type}
      {totalIndex}
      {specData}
      {annotations} />

  </div>

  <div
    class="blockAnnotations"
    style="width: {width + paddingRight}px; right:0px;">

    {#each annotations as a (a.label)}
      {#if a.index == index || (index == totalIndex && a.index == index - 1)}
        <div
          in:fade={{ delay: initialized ? 1500 : 0, duration: initialized ? 500 : 0 }}
          class="svg-label {a.style}
          {a.offsetX ? 's-cline' : ''}"
          style="top: {scale(a.y)}px; left: {width + lineGap}px; max-width: {paddingRight - lineGap}px;">
          {#if a.offsetX}
            <div
              class="custom-line"
              style="left: {-lineGap - ((width - paddingRight - paddingLeft) / specData.groups.length) * (specData.groups.length - Number(a.offsetX))}px;
              width:{lineGap + ((width - paddingRight - paddingLeft) / specData.groups.length) * (specData.groups.length - Number(a.offsetX))}px;
              " />
          {/if}
          <div class="txt">{a.label}</div>
        </div>
      {/if}
    {/each}

  </div>
{/if}
